<div class="modal-header">
  <div>
    <h5 class="modal-title">
      Generate widget customization with AI
    </h5>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="generate()">
    <div class="mb-3">
      <label class="d-block">Generation mode</label>
      <div class="form-check form-check-inline">
        <input id="widget-ai-fresh" class="form-check-input" type="radio"
               value="fresh" formControlName="mode">
        <label class="form-check-label" for="widget-ai-fresh">Create fresh code</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="widget-ai-modify" class="form-check-input" type="radio"
               value="modify" formControlName="mode">
        <label class="form-check-label" for="widget-ai-modify">Modify current code</label>
      </div>
    </div>

    <div class="mb-3">
      <label for="widget-ai-prompt">
        {{ isLegacyConversion ? 'Optional conversion guidance' : 'Describe the customization' }}
      </label>
      <textarea id="widget-ai-prompt" class="form-control" rows="4" maxlength="4000"
                formControlName="prompt"
                placeholder="Describe the desired widget behavior and appearance"></textarea>
      @if (form.get('prompt').touched && form.get('prompt').hasError('required')) {
      <small class="text-danger"
            >
        A prompt is required.
      </small>
      }
      <small class="form-text text-muted text-end">
        {{ form.get('prompt').value?.length || 0 }}/4000
      </small>
    </div>

    @if (error()) {
    <div class="alert alert-danger d-flex align-items-start" role="alert"
         aria-live="assertive">
      <i class="fa fa-exclamation-circle mt-1 me-2" aria-hidden="true"></i>
      <div>
        <strong>
          {{ result() ? 'A new customization wasn’t generated.' : 'Customization wasn’t generated.' }}
        </strong>
        <div>{{ error() }}</div>
      </div>
    </div>
    }

    <div class="d-flex flex-wrap align-items-center">
      <button type="submit" class="btn btn-primary" [disabled]="loading()">
        @if (loading()) {
        <i class="fa fa-spinner fa-spin me-1"></i>
        }
        {{ loading() ? 'Generating…' : (result() ? 'Generate again' : 'Generate') }}
      </button>
      @if (hasLegacyCustomization()) {
      <button type="button" class="btn btn-outline-primary ms-2"
              [disabled]="loading()"
              (click)="convertLegacy()">
        Convert legacy customization with AI
      </button>
      }
    </div>
  </form>

  @if (result(); as result) {
  <div class="widget-ai-result mt-4" aria-live="polite">
    @if (result.summary) {
    <div class="widget-ai-summary mb-3">
      <h6>
        <i class="fa fa-info-circle me-1" aria-hidden="true"></i>
        Summary
      </h6>
      <p>{{result.summary}}</p>
    </div>
    }

    @if (result.warnings?.length) {
    <div class="widget-ai-warnings mb-3" role="alert">
      <h6>
        <i class="fa fa-exclamation-triangle me-1" aria-hidden="true"></i>
        Warnings
      </h6>
      <ul>
        @for (warning of result.warnings; track warning) {
        <li>{{warning}}</li>
        }
      </ul>
    </div>
    }

    <div class="mb-3">
      <label>Generated JavaScript</label>
      <app-ace-editor style="min-height: 260px;" [mode]="'javascript'"
                  [options]="aceEditorOptions" [(text)]="result.custom_script"></app-ace-editor>
    </div>

    <div class="mb-0">
      <label>Generated CSS</label>
      <app-ace-editor style="min-height: 260px;" [mode]="'css'"
                  [options]="aceEditorOptions" [(text)]="result.custom_css"></app-ace-editor>
    </div>
  </div>
  }
</div>

<div class="modal-footer">
  @if (result()) {
  <small class="text-muted me-auto">
    Apply updates the editors only. Use Save on the widget settings page to persist changes.
  </small>
  }
  <button type="button" class="btn btn-default" (click)="activeModal.dismiss()">Cancel</button>
  <button type="button" class="btn btn-primary" [disabled]="!result()" (click)="apply()">
    Apply to editors
  </button>
</div>
